import React, { Component } from 'react';
import { Form, Button,Col, Row, Modal, ListGroup, Tabs, Tab, Table  } from 'react-bootstrap';
import country_list from './_countries'
import { push, replace } from 'react-router-redux'
import {connect} from 'react-redux';
import {alertMess, Spinner_Action} from '../../actions';
import {Elements, CardElement, ElementsConsumer, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import axios from "axios"
import conf from '../../_Conf'

const stripePromise = loadStripe(conf.Production? conf.live_key:conf.test_key);

const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "20px",
        "::placeholder": {
          color: "#aab7c4",
        },
        fontWeight: "500",
        display: "block",
        padding: 500
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };

  class CheckoutForm extends React.Component {
    _create_intent = (event) => {
        event.preventDefault();
        this.props.Spinner_Action({show:true});

        // This timeout is a fallback, but the axios timeout is the primary mechanism
        const spinnerTimeout = setTimeout(() => {
            this.props.Spinner_Action({show: false});
            this.props.alertMess({
                isVis: true,
                message: "Cannot connect to the payment provider. This issue may be caused by network-wide ad blockers or strict organizational firewall settings. Try completing the registration using your phone’s cellular data, or use a different computer or browser.",
                error: true
            });
        }, 15000);

        const {stripe, elements} = this.props;
        if (!stripe || !elements) {
            clearTimeout(spinnerTimeout);
            return;
        }

        axios.post(conf.Production ? conf.ProductionAddress + 'llm2025/p_create_main/' : 'http://127.0.0.1:5050/' + 'llm2025/p_create_main/',
        {
            form: this.props.form
        },
        { 
            headers: { 'Content-Type': 'application/json' },
            timeout: 15000 // Add a 15-second timeout to the axios request
        }
        ).then(response => {
            clearTimeout(spinnerTimeout); // Clear timeout on success
            let client_sec = response.data.client_secret;
            this.handleSubmit(event, client_sec);
        }).catch(err => {
            clearTimeout(spinnerTimeout); // Clear timeout on error
            if (err.response) {
                this.props.alertMess({isVis: true, message: err.response.data.errors, error: true});
            } else {
                this.props.alertMess({
                    isVis: true,
                    message: "Cannot connect to the payment provider. This issue may be caused by network-wide ad blockers or strict organizational firewall settings. Try completing the registration using your phone’s cellular data, or use a different computer or browser.",
                    error: true
                });
            }
            this.props.Spinner_Action({show: false});
        });
    }
    
    
    handleSubmit = async (event, client_sec) => {
        const {stripe, elements} = this.props;

        // You might want a timeout here as well, although Stripe's requests are generally reliable if the initial one succeeds.
        const spinnerTimeout = setTimeout(() => {
            this.props.Spinner_Action({show: false});
            this.props.alertMess({
                isVis: true,
                message: "Payment confirmation is taking longer than expected. Please check your internet connection.",
                error: true
            });
        }, 15000);

        if (!stripe || !elements) {
            clearTimeout(spinnerTimeout);
            this.props.Spinner_Action({show:false});  
            this.props.alertMess({isVis: true, message:"Please submit again", error:true});
            return;
        }

        const result = await stripe.confirmCardPayment(client_sec, {
            payment_method: {
              card: elements.getElement(CardElement),
              billing_details: {
                name: this.props.form.fn + " " + this.props.form.ln,
              },
            }
          });
      
          clearTimeout(spinnerTimeout); // Clear the timeout regardless of the outcome
          if (result.error) {
            this.props.alertMess({isVis: true, message:result.error.message, error:true});
            this.props.Spinner_Action({show:false});
          } else {
            // The payment has been processed!
            if (result.paymentIntent.status === 'succeeded') {
                console.log("OK!", result);
                this.props.Spinner_Action({show:false});
                this.props.replace(
                  {
                      pathname: '/LLM2025/registration_success',
                      state: { form: this.props.form, result: result }
                  });
            }
          }
  
    };
  
    render() {
      return (
        <Form onSubmit={this._create_intent}>
          <div>
            <CardElement options={CARD_ELEMENT_OPTIONS}  />
          </div>

          <div style={{"textAlign": "center", margin: "0 auto"}}>
                <Button type="submit" style={{margin: "0.5rem", marginTop: "2rem"}} 
                disabled={
                  !this.props.stripe
                }
                >Confirm and Pay</Button>
                <Button style={{margin: "0.5rem", marginTop: "2rem", backgroundColor:"red", borderColor: "white"}} onClick={()=>{
                    this.props.push("/LLM2025/registration_start")
                }}>Cancel</Button>
            </div>
        </Form> 

      );
    }
  }

class Reg_Card extends Component {
    constructor(props) {
        super(props)
        this.state = {
            form: {}
        }
    }

    componentWillMount = () => {
        try {
            let st = this.props.location.state.form
            this.setState({
                form: st
            })
        } catch {
            this.props.replace("/LLM2025/registration_start")
        }
    }

    render() {
    return (
        <div className="r_container">
        <div className="home">
            <div className="new_banner">
                <div className="banner_content">
                <h1>LLM 2025</h1>
                
                <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
                <h6>December 3-5, 2025, Las Vegas, USA</h6>
                </div>

                <div className="new_banner_overlay"></div>
            </div>

            <div className="page_content">
                <h6 className="par_header">Registration - Confirm and Pay</h6>
                <div className="reg_form">

                  <div className="confirm_everything">
                    <div>
                      <b>Name:</b> {this.props.location.state.form.title} {this.props.location.state.form.fn} {this.props.location.state.form.ln}
                    </div>
                    <div>
                      <b>Email: </b> {this.props.location.state.form.email}
                    </div>
                    <div>
                      <b>University/College/Company: </b> {this.props.location.state.form.uni}
                    </div>
                    <div>
                      <b>Country: </b> {this.props.location.state.form.country}
                    </div>
                    <div>
                      <b>Are you a Full Time student: </b> {this.props.location.state.form.isStudent? "Yes": "No"}
                    </div>
                    <div>
                      <b>Are you registering as an Author: </b> {this.props.location.state.form.isAuthor? "Yes": "No"}
                    </div>
                    <div>
                      <b>Number of papers: </b> {this.props.location.state.form.pc}
                    </div>
                    {this.props.location.state.form.pc >= 1 &&
                    <div>
                      <b>Paper 1: </b> {this.props.location.state.form.p1_id} - {this.props.location.state.form.p1_title}
                    </div>
                    }
                    {this.props.location.state.form.pc >= 2 &&
                    <div>
                      <b>Paper 2: </b> {this.props.location.state.form.p2_id} - {this.props.location.state.form.p2_title}
                    </div>
                    }
                    {this.props.location.state.form.pc >= 3 &&
                    <div>
                      <b>Paper 3: </b> {this.props.location.state.form.p3_id} - {this.props.location.state.form.p3_title}
                    </div>
                    }
                    <div>
                    <b>Total: </b> 
                      <b style={{color: "red"}}>
                      {
                        (()=>{
                          let cost = 0
                          if(this.props.location.state.form.isStudent == 1){
                            cost = 575
                          }else{
                            cost = 675
                          }
                          if(this.props.location.state.form.pc){
                            cost += 495 * (this.props.location.state.form.pc - 1)
                          }
                          return "$" + cost + ".00"
                        })()
                      }
                      </b>
                    </div>

                  

                  </div>
                  <div className="pay_el">
                    <Elements stripe={stripePromise}>
                        <ElementsConsumer>
                        {({stripe, elements}) => (
                            <CheckoutForm  stripe={stripe} elements={elements} 
                            alertMess={this.props.alertMess} 
                            push={this.props.push} 
                            replace={this.props.replace}
                            form={this.state.form} 
                            Spinner_Action={this.props.Spinner_Action}
                            Spinner_ActionReducer={this.props.Spinner_ActionReducer}
                            />
                        )}
                        </ElementsConsumer>
                    </Elements>
                  </div>
                </div>

            </div>
        
        
        </div>
        </div>

    );
  }
}

const mapStateToProps = state => {
    return {
        alertReducer: state.alertReducer,
        Spinner_ActionReducer: state.Spinner_ActionReducer,
    }
  }
  
  const mapDispatchToProps = () => {
    return {
      push,
      alertMess,
      Spinner_Action,
      replace
    }
  }
export default connect(mapStateToProps, mapDispatchToProps())(Reg_Card);